import React from 'react';
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

import * as LINKS from "../../../../const/links";
import Arrows from "../Ui/Arrow";
import {usePaymentState} from "../../../../hooks/usePaymentState";

export function Steps() {
  const { t } = useTranslation();
  const {paymentDetails,paymentURL}=usePaymentState();
  const {venueName} = paymentDetails;
  
  return [
    {
      main: {
        title: venueName,
        description: t("payments.wizard.description"),
      },
      indicator: {
        icon: "Inactive",
        text: t("payments.wizard.step1.text"),
      },
      showSteps: true,
      title: t("payments.wizard.step1.title"),
      caption: (
        <div>
          <Trans i18nKey="payments.wizard.step1.caption">
            0
            <a rel="noopener noreferrer" target="_blank" href={LINKS.SIGN_UP}>
              1
            </a>
            2.
          </Trans>
        </div>
      ),
      content: (
        <p>
          <Trans i18nKey="payments.wizard.step1.content">
            <i>0</i>
            <br />
            <i>2</i>.
          </Trans>
        </p>
      ),
      button: {
        text: t("payments.wizard.step1.button"),
        url: paymentURL,
        target: "_self",
        disabled: !(paymentURL && paymentURL.length > 0),
        icon: <Arrows/>
      },
    },
    {
      main: {
        title: venueName,
        description: t("payments.wizard.description"),
      },
      indicator: {
        icon: "Inprogress",
        text: t("payments.wizard.step2.text"),
      },
      showSteps: true,
      title: t("payments.wizard.step2.title"),
      caption: (
        <div>
          <Trans i18nKey="payments.wizard.step2.caption">
            <div style={{ marginBottom: "1rem" }}>0</div>1
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={LINKS.INCORPORATED}
            >
              2
            </a>
            <br />4
            <a rel="noopener noreferrer" target="_blank" href={LINKS.SOLO}>
              5
            </a>
          </Trans>
        </div>
      ),
      content: (
        <p>
          <Trans i18nKey="payments.wizard.step2.content">
            0 <b>1</b>2
            <br />4 <b>5</b> 6
          </Trans>
        </p>
      ),
      button: {
        text: t("payments.wizard.step2.button"),
        url: paymentURL + "#/account",
        target: "_blank",
        disabled: !(paymentURL && paymentURL.length > 0),
        icon: <Arrows/>
      },
    },
    {
      main: {
        title: venueName,
        description: t("payments.wizard.description"),
      },
      indicator: {
        icon: "Inprogress",
        text: t("payments.wizard.step3.text"),
      },
      showSteps: true,
      title: t("payments.wizard.step3.title"),
      caption: <div></div>,
      content: (
        <p>
          <Trans i18nKey="payments.wizard.step3.content">
            0 <b>1</b> 2
            <br />4 <b>5</b> 6
            <br />8
          </Trans>
        </p>
      ),
      button: {
        text: t("payments.wizard.step3.button"),
        url: paymentURL + "#/account",
        target: "_blank",
        disabled: !(paymentURL && paymentURL.length > 0),
        icon: <Arrows/>
      },
    },
    {
      main: {
        title: venueName,
        description: "",
      },
      indicator: {
        icon: "Inactive",
        text: t("payments.wizard.step4.text"),
      },
      showSteps: false,
      title: t("payments.wizard.step4.title"),
      caption: <div></div>,
      content: (
        <p>
          <Trans i18nKey="payments.wizard.step4.content">
            0 <b>1</b> 2 <b>3</b> 4
            <br /><br />
            6
            <br /><br />
            9 <b>10</b> 11
          </Trans>
        </p>
      ),
      button: {
        text: t("payments.wizard.step4.button"),
        url: paymentURL + "#/account",
        target: "_blank",
        disabled: !(paymentURL && paymentURL.length > 0),
        icon: <Arrows/>
      },
    },
    {
      main: {
        title: venueName,
        description: "",
      },
      indicator: {
        icon: "Active",
        text: t("payments.wizard.step5.text"),
      },
      showSteps: false,
      title: t("payments.wizard.step5.title"),
      caption: <div></div>,
      content: (
        <p>
        </p>
      ),
      button: {
        text: t("payments.wizard.step5.button"),
        url: paymentURL,
        target: "_blank",
        disabled: !(paymentURL && paymentURL.length > 0),
        icon: <Arrows/>
      },
    },
  ];
}
